import { render, staticRenderFns } from "./Part3OpinionEssay.vue?vue&type=template&id=b629a794&scoped=true"
import script from "./Part3OpinionEssay.vue?vue&type=script&lang=js"
export * from "./Part3OpinionEssay.vue?vue&type=script&lang=js"
import style0 from "./Part3OpinionEssay.vue?vue&type=style&index=0&id=b629a794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b629a794",
  null
  
)

export default component.exports